/* eslint-disable */
import { Vue, sessionManager, Logger, gChannel } from 'vue-infra';
import {has, includes, get, replace} from 'lodash';
import routes from './router';
import Config from 'config';
import PortalVue from 'portal-vue';
import { FEATURES, PRIVILEGES, SESSION_SETTINGS } from './store/modules/data/logged-in-user/consts';
// import AMSClient from 'ams-client/dist/AMSClientV2';


const AppVue = r => require.ensure([], () => r(require('./App.vue')), 'AppVue');
const awStore = r => require.ensure([], () => r(require('./store')), 'awStore');

const logger = Logger.getLogger('agentWorkspaceApp');
let agentTemporaryStatusOptions;

if (window._) {
  window._.noConflict();
}

function loadInContext(filename) {
  return new Promise((resolve) => {
    if (filename === 'en-US') {
      // en-US is excluded from bundle-loader and pre-loaded by default
      require([`./i18n/dictionaries/${filename}.json`], resolve);
    } else {
      // all other locals are loaded dynamically using the bundle-loader
      require(`./i18n/dictionaries/${filename}.json`)((dict) => {
        resolve(dict);
      });
    }
  });
}

async function loadLocal(locale, fallbackLocale) {
  const local = {};
  // load custom local
  try {
    local.localResource = await loadInContext(locale);
  }
  catch(e){
    logger.error(`fail to load dictionary ${locale}`);
  }
  // load fallback local
  if(locale !== fallbackLocale){
    try {
      local.fallbackLocaleResource = await loadInContext(fallbackLocale);
    }
    catch(e) {
      logger.error(`fail to load dictionary ${fallbackLocale}`);
    }
  }
  return local

}
/**
 *
 * @param appConfig
 * @returns {Promise<{}>}
 * @description INIT ALL APPLICATION DEPENDENCIES
 * please notice that the order of functions in "applicationInit" is critical,
 * change with extra care.....
 */
const applicationInit = async (appConfig, LEConfig) => {
  const store = new Vue().$store;
  // check for privileges. if there is - return the config.applicationName / else - return nothing
  if (store && hasMessagingFeature(appConfig, store) && canViewAgentWorkspace(appConfig, store)) {

    gChannel.register('LiveEngageCommon', 'agentStatus:requestUMSChange', updateAgentTemporaryStatusOptions); // in case there is status change triggered before the awStore is running

    // TODO: take all this code to a different file for the good of order
    awStore((module) => {
      store.dispatch('aw/data/loggedInUser/initUserPrivileges', (appConfig && appConfig.config) || {});
      store.dispatch('aw/data/conversations/initializeNowCount');
      store.dispatch('aw/data/conversations/startSubscription');
      store.dispatch('aw/data/rings/startSubscription');
      if(!preventUpdateAgentStatusInUMS()) {
        store.dispatch('aw/data/rings/watchAgentStatusChanges');
        gChannel.unregister({ appName: 'LiveEngageCommon', eventName: 'agentStatus:requestUMSChange', func: updateAgentTemporaryStatusOptions }); // remove the temporary listener
        if (agentTemporaryStatusOptions) {
          gChannel.trigger('LiveEngageCommon', 'agentStatus:requestUMSChange', agentTemporaryStatusOptions);
        }
      }
      store.dispatch('aw/data/conversations/setConversationUpdateStrategy', appConfig.isNewConversationUpdateStrategy);
      if (isContactCenterEnabled()) {
        store.dispatch('aw/data/multiAccount/init');
        store.dispatch('aw/data/conversations/startContactCenterSubscription');
      }
    });

    registerVueGlobalComponent();
    const locale = await loadLocal(appConfig.locale, appConfig.fallbackLocale || appConfig.defaultLocale); // appConfig.defaultLocale will deprecate at LE 10.8
    require('./sass/style.scss');

    return {
      i18nResource: locale.localResource, // will deprecate at LE 10.8
      fallbackI18nResource: locale.fallbackLocaleResource, // will deprecate at LE 10.8
      appLocaleResource: locale.localResource,
      appFallbackLocaleResource: locale.fallbackLocaleResource,
      routes,
      appId: Config.applicationName,
    };
  } else {
    return {};
  }
};

function updateAgentTemporaryStatusOptions(options) {
  agentTemporaryStatusOptions = options;
}

const registerVueGlobalComponent = () => {
  Vue.use(PortalVue, {
    portalName: 'aw-portal',
    portalTargetName: 'aw-portal-target',
  });

  // Register the component globally to get the Vue dev tools working.
  // load dictionaries only after the app load approved
  Vue.component(Config.applicationName, {
    name: Config.applicationName,
    template: '<App/>',
    components: {App: AppVue},
  });
};

const canViewAgentWorkspace = (appConfig, store) => {
  return (canViewByConfig(appConfig, store) || canViewByPrivilege(appConfig, store) || canViewBySiteSetting() ||
    canViewByEnforceNewAgentWorkspaceFeature() || isLPAWithNAWEnabled(store)) && isLPANotDisabled(store);
};

const canViewByConfig = (appConfig, store) => {
  let canView = false;

  if (has(appConfig, 'allowedAccounts')) {
    const allowedAccounts = appConfig.allowedAccounts;
    const accountId = store.getters['session/getValue']('accountId');
    const userId = store.getters['session/getValue']('userId');
    const accountConfiguration = allowedAccounts['*'] || allowedAccounts[accountId];
    if (accountConfiguration) {
      if (includes(accountConfiguration, '*') || includes(accountConfiguration, userId)) {
        canView = true;
      }
    }
  }

  return canView;
};


const canViewByPrivilege = (appConfig, store) => {
  let canView = false;

  const viewWorkspaceFeature = sessionManager.getFeaturePropertyState(FEATURES.AGENT_WORKSPACE_FEATURE);
  const viewWorkspacePrivilege = sessionManager.hasPrivilege(Number(PRIVILEGES.VIEW_AGENT_WORKSPACE));
  const hasMessagingPrivilege = sessionManager.hasPrivilege(Number(PRIVILEGES.VIEW_ACTIVE_CONNECTIONS));
  if (viewWorkspaceFeature && viewWorkspacePrivilege && hasMessagingPrivilege) {
    canView = true;
  }

  return canView;
};

const canViewByEnforceNewAgentWorkspaceFeature = () => {
  const enforceNewAgentWorkspaceFeature = sessionManager.getFeaturePropertyState(FEATURES.ENFORCE_NEW_AGENT_WORKSPACE);
  const hasMessagingPrivilege = sessionManager.hasPrivilege(Number(PRIVILEGES.VIEW_ACTIVE_CONNECTIONS));
  return enforceNewAgentWorkspaceFeature && hasMessagingPrivilege;
};

const preventUpdateAgentStatusInUMS = () => {
  return  sessionManager.getFeaturePropertyState(FEATURES.PREVENT_UPDATE_AGENT_STATUS_AT_UMS);
};

const canViewBySiteSetting = () => {
  const showNewAgentWorkspace = sessionManager.getAccountSettingValueByID(SESSION_SETTINGS.SHOW_NEW_AGENT_WORKSPACE, false);
  const hasMessagingPrivilege = sessionManager.hasPrivilege(Number(PRIVILEGES.VIEW_ACTIVE_CONNECTIONS));
  const canView = (showNewAgentWorkspace === 'true') && hasMessagingPrivilege;
  return canView;
};

const hasMessagingFeature = (appConfig, store) => {
  let messagingFeature = sessionManager.getFeatureProperty(FEATURES.ASYNC_MESSAGING);
  return messagingFeature && messagingFeature.value && messagingFeature.value.value;
};

function isLPANotDisabled(store) {
  return get(LPASettingsForNAW(store), 'newAgentWorkspace') !== 'false';
}

function isLPAWithNAWEnabled(store) {
  return get(LPASettingsForNAW(store), 'newAgentWorkspace') === 'true';
}

function isContactCenterEnabled(){
  const contactCenterFeatureObj = sessionManager.getFeatureProperty(FEATURES.CONTACT_CENTER);
  const isContactCenterFeatureActivated = get(contactCenterFeatureObj, 'value.value', false);
  const contactCenterAgentPrivilege = sessionManager.hasPrivilege(Number(PRIVILEGES.ANSWERING_SERVICE_AGENT));
  return isContactCenterFeatureActivated && contactCenterAgentPrivilege;
}

function LPASettingsForNAW(store) {
  let lpaSettings;
  if (isLPA(store)) {
    const newAgentWorkspaceForLPASettings = store.getters['session/getSettingsMap']()[SESSION_SETTINGS.NEW_AGENT_WORKSPACE_LPA];
    const loginName = store.getters['session/getConfig']().loginName;
    const lpaName = replace(loginName, 'LPA-', '');
    lpaSettings = get(newAgentWorkspaceForLPASettings, ['propertyValue', 'value', lpaName]);
  }
  return lpaSettings;
}

function isLPA(store) {
  return store.getters['session/getConfig']().isLPA;
}

const webpackPathInit = (appConfig) => {
  __webpack_public_path__ = appConfig.publicPath;
};

const App = {
  webpackPathInit,
  applicationInit,
  keepDOMRendered: true,
  config: {
    // A change in the 'id' property will require a code change
    id: 'agentworkspace',
    external: true,
    moduleName: 'LEWebAgentVeu',
    folderName: 'web-agent-vue-wrapper',
    regionId: 'web-agent-vue',
    container: 'work-area-wrapper',
    template: 'workAreaItemNoLEClass',
    routePrefix: 'aw',
    personaMapping: 'messagingAgent',
    personas: ['agent', 'messagingAgent', 'agentManager'],
    lazy: true,
    autostart: true,
    transition: true,
    switcher: {
      control: 'switcher-item-agent-workspace',
      fontIconName: 'ico-aw',
      index: 30, // should come from
      tooltipTranslationKey: true,
      // you can apply the
      // title: 'some tooltip key for languino',
      // tooltip: 'some tooltip key for languino',
    }
  }
};


export default App;
